import { put, takeLatest, all, call, select } from "redux-saga/effects";
// import { put, takeLatest, all, call,select } from "redux-saga/effects";
import { api, nodeApi } from "../../service/apiService";
import {
    employeeDiscountValidationUrl,
    zipCodeApiUrl,
    cardNumberApiUrl,
    employeeDiscountFormSubmitUrl, getSubscriptionKey,
    getAccessDetail,
    getOtpApiUrl
} from "../../service/apiUrls";
import { serviceInProgress } from "../../component/containers/loader/LoaderAction";
import { userRole } from "../../utils/FieldKeyConstants";
import { authTokenCookie } from '../../utils/CookieMaker';
import * as selectors from './selectors';
import {
    VALIDATE_EMPLOYEE_ID,
    setEmployeeValidationData,
    setEmployeeValidationSucessMessage,
    setEmployeeValidationErrorMessage,
    setCardNumberData,
    resetEmployeeValidationData,
    setEmployeeAccountSuccessMessage,
    setEmployeeAccountWarningMessage,
    setEmployeeAccountErrorMessage,
    setEmployeeOtpSuccessMessage,
    setEmployeeOtpErrorMessage,
    setEmployeeGetOtpSuccessMessage,
    setEmployeeGetOtpErrorMessage,
    setOtpData,
    setZipCodeData,
    setZipCodeErrorMessage,
    setZipCodeSuccessMessage,
    GET_ZIPCODE,
    SAVE_EMPLOYEE_DISCOUNT_FORM,
    setEmployeeDiscountFormSuccessMessage,
    setEmployeeDiscountFormErrorMessage,
    GET_CARD_NUMBER, GET_APIMKEY, setAPIMKey,
    GET_ACCESSDETAILS, setAccessDetails,
    VALIDATE_OTP,
    GET_OTP
} from "../../component/Screens/employeeDiscount/employeeDiscountForm/employeeDiscountFormAction";

import {
    setRole,
    GET_ROLE,
} from "../../component/Screens/employeeDiscount/employeeDiscountForm/employeeDiscountFormAction";
import { serviceError } from "../../common/ServiceError/ServiceErrorAction";

function exceptionFormatter(exp) {
    if (exp.config) {
        return { message: "System is unable to process this request at the moment, please contact the System Administrator." }
    }
    else return { exp, url: ``, method: `` }
}

function isJWTNotExpired() {
    let tokenNotExpired = true;
    let currentDate = new Date();
    let currentTime = currentDate.getTime();
    let { decodedIdToken, authCookie, userInfo } = authTokenCookie();
    // JWT exp is in seconds
    let sessionId = sessionStorage.getItem('sessionId')
    if (authCookie.name && sessionId === userInfo.userId) {
        let tokenExpiry = decodedIdToken.exp * 1000;
        if (tokenExpiry < currentTime) {
            tokenNotExpired = false;
        }
    }
    return tokenNotExpired;
}

function* get_AccessDetails(userInfo) {
    try {
        if (isJWTNotExpired()) {
            yield put(serviceInProgress(true));
            // JWTExpirationCheck();
            // let subKey = yield select(selectors.key);
            let subKey = yield select(selectors.key);
            let request = {
                "userNameRole": userInfo?.value?.userRole,
                "userName": userInfo?.value?.userId
            }
            let res = yield call(() => { return api(getAccessDetail.url, getAccessDetail.method, request, subKey) })

            yield put(setAccessDetails(res?.data))
            yield put(serviceInProgress(false));
        }
    }
    catch (exp) {
        yield put(serviceInProgress(false));
        yield put(serviceError(exceptionFormatter(exp)));
    }
}

function* saveEmployeeDiscountFormData(params) {
    const requestData = params.payload;
    try {
        yield put(serviceInProgress(true));
        let subKey = yield select(selectors.key);//`ba4909348805407698041ae74a476137`;

        let responseData = yield call(() => {
            return api(
                employeeDiscountFormSubmitUrl.url,
                employeeDiscountFormSubmitUrl.methodType,
                requestData,
                subKey
            );
        });

        if (responseData.status === 200) {
            yield put(
                setEmployeeDiscountFormSuccessMessage(responseData.data.informationMessage)
            );
        }
        yield put(serviceInProgress(false));
    } catch (err) {
        let message = "";
        switch (err && err.response.status) {
            case 409:
                message = err.response.data.errorList[0];
                yield put(setEmployeeDiscountFormErrorMessage(message));
                break;
            case 404:
                message = `Your request has been submitted to our support team. Please allow 24-72 hours for your employee discount to be added.`;
                yield put(setEmployeeDiscountFormSuccessMessage(message));
                break;
            case 400:
                message = err.response.data.errorList[0];
                yield put(setEmployeeDiscountFormErrorMessage(message));
                break;
            default:
                yield put(serviceError(exceptionFormatter(err)));
                break;
        }

        yield put(serviceInProgress(false));
    }
}

function* get_SubKey() {
    try {
        let response = yield call(() => { return nodeApi(getSubscriptionKey.url, getSubscriptionKey.method) });
        // let response = yield call(() => { return nodeApi(`https://svwp-ctl-ui-dev.apps.np.stratus.albertsons.com/api/getSubKey`,`GET`) });
        let key = response && response.data && response.data.subKey;
        let dashboardurl = response && response.data && response.data.dashboardurl;
        yield put(setAPIMKey(key,dashboardurl));
    }
    catch (exp) {
        console.log(`APIM Key exception`, exp);
    }
}


function* getEmployeeValidationData(params) {
    let empID = params.payload;
    try {
        yield put(serviceInProgress(true));
        let subKey = yield select(selectors.key); // `ba4909348805407698041ae74a476137`;
        let responseData = yield call(() => {
            return api(
                employeeDiscountValidationUrl.url + "/" + empID,
                employeeDiscountValidationUrl.methodType, ``, subKey
            );
        });

        if (responseData && responseData.status === 200) {
            console.log(responseData.data);
            yield put(setEmployeeValidationData(responseData.data));
            yield put(
                setEmployeeValidationSucessMessage(
                    "Thank you. Please proceed with Step 2: Look-up Card Number, Email or Phone Number"
                )
            );
        }
        yield put(serviceInProgress(false));
    } catch (err) {
        console.log(err, `err`);
        let message = "";
        if (err && err.response.status === 404) {
            message =
                "Invalid Employee ID. New employees: it may take up to 24 hours (from your hire date) for your Employee’s Id to be active in the system. If less than 24hrs, please try again tomorrow. All others, to obtain your PeopleSoft employee id, please check your new hire paperwork or online pay stub. If you are unable to locate your employee id, please contact HR at 1-888-255-2269";
            yield put(setEmployeeValidationErrorMessage(message));
        } else if (err && err.response.status === 503) {
            yield put(serviceError(exceptionFormatter(err)));
            yield put(setEmployeeValidationData({}));
        } else {
            yield put(serviceError(exceptionFormatter(err)));
            yield put(setEmployeeValidationData({}));
        }
        yield put(serviceInProgress(false));
    }
}
export function* getZipCode(params) {
    let zipCode = params.payload;

    try {
        yield put(serviceInProgress(true));
        let subKey = yield select(selectors.key); //`ba4909348805407698041ae74a476137`;//
        let responseData = yield call(() => {
            return api(
                zipCodeApiUrl.url + "=" + zipCode,
                zipCodeApiUrl.methodType, ``, subKey
            );
        });
        console.log(responseData);
        if (responseData.status === 200) {
            yield put(setZipCodeData(responseData.data));
            yield put(setZipCodeSuccessMessage("zipCode data found!"));
            yield put(resetEmployeeValidationData("step4", 4));
        }
        yield put(serviceInProgress(false));
    } catch (err) {
        let message = "";
        if (err && err.response) {
            if (err.response.status === 404) {
                message = "Zip code not found";
                yield put(setZipCodeErrorMessage(message));
                yield put(resetEmployeeValidationData("step4", 4));
            } else if (err.response.status === 503) {
                yield put(serviceError(exceptionFormatter(err)));
                yield put(setZipCodeErrorMessage(message));
            } else {
                yield put(serviceError(exceptionFormatter(err)));
                yield put(setZipCodeErrorMessage(message));
            }
        }
        yield put(setZipCodeData({}));
        yield put(serviceInProgress(false));
    }
}

function* get_Role() {
    try {
        yield put(serviceInProgress(true));
        const data = userRole;
        yield put(setRole(data));
        yield put(serviceInProgress(false));
    } catch (exp) {
        yield put(serviceInProgress(false));
    }
}
export function* getCardNumber(cardNumberObj) {
    let cardNumber = cardNumberObj.payload.cardNumber.clubCardNumber;
    let phoneNumber = cardNumberObj.payload.cardNumber.phoneNumber;
    let email = cardNumberObj.payload.cardNumber.emailAddress;
    const empId = cardNumberObj.payload.empId;
    const requestData = { employeeId: empId };

    let ErrorMsg = '';

    if (cardNumber !== "") {
        requestData.clubCardNumber = cardNumber;
        ErrorMsg = 'Account validation failed: The entered club card number is not associated with your customer account. Please register online and try again';
    }
    if (phoneNumber !== "") {
        requestData.phoneNumber = phoneNumber;
        ErrorMsg = 'Account validation failed: The entered phone number is not associated with your customer account. Please register online and try again';
    }
    if (email !== "") {
        requestData.emailAddress = email;
        ErrorMsg = 'Account validation failed: The entered email id is not associated with your customer account. Please register online and try again';
    }

    yield put(serviceInProgress(true));
    try {
        let subKey = yield select(selectors.key); //`ba4909348805407698041ae74a476137`;// 
        let responseData = yield call(() => {
            return api(
                cardNumberApiUrl.url,
                cardNumberApiUrl.methodType,
                requestData, subKey
            );
        });
        console.log(responseData, 'responseData');
        let otpType = '';
        let toggleOption = false;
        let warningMsg = '';
        if (responseData.status === 200) {
            if (responseData.data.smsFactorId !== null && responseData.data.emailFactorId !== null) {
                otpType = 'mobile';
                toggleOption = false;
            } if (responseData.data.emailFactorId === null && responseData.data.smsFactorId !== null) {
                otpType = 'mobile';
                toggleOption = true;
            } if (responseData.data.emailFactorId !== null && responseData.data.smsFactorId === null) {
                otpType = 'email';
                toggleOption = true;
            }

            if ((responseData.data.phoneNumber === null || responseData.data.phoneNumber === '') && (responseData.data.emailAddress === null || responseData.data.emailAddress === '')) {
                warningMsg = 'Account validation successful. Warning: There is no email id or phone number is associated with your customer account. Please contact customer care to get them updated';
            }

            if (responseData.data.phoneNumber !== null && responseData.data.phoneNumber !== null && responseData.data.eligibleForOtp === false) {
                warningMsg = 'Account validation successful. One Time Pin validation is not applicable as the associated phone/email is not eligible';
            }

            const resData = {
                ...responseData.data,
                targetInput: cardNumberObj.payload.cardNumber.targetInput,
                otpType: otpType,
                toggleOption: toggleOption,
            };
            yield put(setCardNumberData(resData));
            if (warningMsg !== '') {
                yield put(setEmployeeAccountWarningMessage(warningMsg));
            } else {
                let successMsg =
                    "Valid Account. Please proceed with Step 3: OTP Validation";

                yield put(setEmployeeAccountSuccessMessage(successMsg));
            }


        }
        if (responseData.status === 204) {
            let message = "";
            message = ErrorMsg;

            yield put(setEmployeeAccountErrorMessage(message));
        }
        yield put(serviceInProgress(false));
    } catch (err) {
        let message = "";
        switch (err && err.response.status) {
            case 404:
                message = ErrorMsg;

                yield put(setEmployeeAccountErrorMessage(message));
                break;
            case 400:
                message = ErrorMsg;

                yield put(setEmployeeAccountErrorMessage(message));
                break;
            case 503:
                yield put(serviceError(exceptionFormatter(err)));
                break;
            case 500:
                yield put(serviceError(exceptionFormatter(err)));
                break;
            default:
                yield put(serviceError(exceptionFormatter(err)));
                break;
        }

        yield put(serviceInProgress(false));
    }
}
export function* validateEdOtp(otpData) {
    let factorId = otpData.payload.factorId;
    let loginId = otpData.payload.loginId;
    // let inputSouce = otpData.payload.source;
    let passCode = otpData.payload.passCode;
    yield put(serviceInProgress(true));

    const requestData = {
        factorId: factorId,
        loginId: loginId,
        passCode: passCode,
    };

    try {

        let subKey = yield select(selectors.key);
        let responseData = yield call(() => {
            return api(
                getOtpApiUrl.url,
                `POST`,
                requestData,
                subKey
            );
        });

        if (responseData.status === 200) {
            yield put(setOtpData(otpData.payload));
            let successMsg =
                "Thank you! The One Time Pin has been successfully validated";

            yield put(setEmployeeOtpSuccessMessage(successMsg));
        }


        yield put(serviceInProgress(false));
    } catch (err) {
        let message = "";
        switch (err && err.response.status) {
            case 404:
                message =
                    "One Time Pin expired or Incorrect One Time Pin! Please re enter the OTP or click on 'Resend OTP' to get a new OTP";

                yield put(setEmployeeOtpErrorMessage(message));
                break;
            case 400:
                message =
                    "One Time Pin expired or Incorrect One Time Pin! Please re enter the OTP or click on 'Resend OTP' to get a new OTP";

                yield put(setEmployeeOtpErrorMessage(message));
                break;
            case 503:
                yield put(serviceError(exceptionFormatter(err)));
                break;
            case 500:
                yield put(serviceError(exceptionFormatter(err)));
                break;
            default:
                yield put(serviceError(exceptionFormatter(err)));
                break;
        }

        yield put(serviceInProgress(false));
    }
}
export function* getOtpData(otpData) {
    let factorId = otpData.payload.factorId;
    let loginId = otpData.payload.loginId;
    let inputSouce = otpData.payload.source;
    yield put(serviceInProgress(true));

    try {
        let subKey = yield select(selectors.key);
        let responseData = yield call(() => {
            return api(
                getOtpApiUrl.url + `?loginId=${loginId}&factorId=${factorId}`,
                getOtpApiUrl.methodType,
                ``,
                subKey
            );
        });

        if (responseData.status === 200) {
            let successMsg = '';
            if (inputSouce === 'mobile') {
                successMsg =
                    "One OTP has been sent to your below mentioned mobile number. Please enter and validate the OTP to verify your registered mobile phone number.";
            } else {
                successMsg =
                    "One OTP has been sent to your below mentioned email address. Please enter and validate the OTP  to verify your registered email address.";
            }
            yield put(setEmployeeGetOtpSuccessMessage(successMsg));

        }

        yield put(serviceInProgress(false));
    } catch (err) {
        let message = "";
        switch (err && err.response.status) {
            case 404:
                message =
                    "Unable to process the request, please try after sometime";

                yield put(setEmployeeGetOtpErrorMessage(message));
                break;
            case 400:
                message =
                    "Unable to process the request, please try after sometime";

                yield put(setEmployeeGetOtpErrorMessage(message));
                break;
            case 503:
                message =
                    "Unable to process the request, please try again";

                yield put(setEmployeeGetOtpErrorMessage(message));
                break;
            case 500:
                message =
                    "Unable to process the request, please try again";

                yield put(setEmployeeGetOtpErrorMessage(message));
                break;
            default:
                message =
                    "Unable to process the request, please try again";

                yield put(setEmployeeGetOtpErrorMessage(message));
                break;
        }

        yield put(serviceInProgress(false));
    }
}

function* Watcher() {
    yield takeLatest(GET_APIMKEY, get_SubKey);
    yield takeLatest(GET_ACCESSDETAILS, get_AccessDetails);
    yield takeLatest(VALIDATE_EMPLOYEE_ID, getEmployeeValidationData);
    yield takeLatest(GET_ROLE, get_Role);
    yield takeLatest(GET_ZIPCODE, getZipCode);
    yield takeLatest(SAVE_EMPLOYEE_DISCOUNT_FORM, saveEmployeeDiscountFormData);
    yield takeLatest(GET_CARD_NUMBER, getCardNumber);
    yield takeLatest(VALIDATE_OTP, validateEdOtp);
    yield takeLatest(GET_OTP, getOtpData);
}

// notice how we now only export the rootSaga
// single entry point to start all Sagas at once
export default function* rootSaga() {
    yield all([Watcher()]);
}
